import React from 'react';
import './Divider.scss';

const Divider: React.FC = () => {
  return <div className="sb-divider" />;
};

export default Divider;
